// utils/encryption.ts (append below encryptAES)

export async function decryptAES(encryptedBase64: string, password: string): Promise<string> {
	try {
		const dec = new TextDecoder();

		// Decode base64 to Uint8Array
		const binary = atob(encryptedBase64);
		const buffer = new Uint8Array(binary.length);
		for (let i = 0; i < binary.length; i++) {
			buffer[i] = binary.charCodeAt(i);
		}

		// Extract salt, IV, and encrypted data
		const salt = buffer.slice(0, 16);
		const iv = buffer.slice(16, 32);
		const encryptedData = buffer.slice(32);

		// Re-derive key
		const keyMaterial = await crypto.subtle.importKey(
			"raw",
			new TextEncoder().encode(password),
			{ name: "PBKDF2" },
			false,
			["deriveKey"]
		);

		const key = await crypto.subtle.deriveKey(
			{
				name: "PBKDF2",
				salt,
				iterations: 100000,
				hash: "SHA-256"
			},
			keyMaterial,
			{ name: "AES-CBC", length: 256 },
			false,
			["decrypt"]
		);

		// Decrypt
		const decryptedBuffer = await crypto.subtle.decrypt({ name: "AES-CBC", iv }, key, encryptedData);
		return dec.decode(decryptedBuffer);
	} catch (error) {
		// console.log("decryption error", error);
		return "ERROR";
	}
}
